module.exports = __webpack_public_path__ + "img/en-box4-text-light.d9794a54.png";